import { createContext, useContext } from 'react';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';

// Auth0 configuration
const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
const AUTH0_CALLBACK_URL = import.meta.env.VITE_AUTH0_CALLBACK_URL;

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
};

// Custom hook for using auth
export const useAuth = () => {
  const auth = useAuth0();
  
  if (auth === null) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  
  return auth;
}; 